<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('operationEntityDataMapping.detail.id') }}</vl-properties-label>
    <vl-properties-data>
      {{ props.detail.id }}
    </vl-properties-data>
    <vl-properties-label>{{ $t('operationEntityDataMapping.detail.fromEntity') }}</vl-properties-label>
    <vl-properties-data>
      {{ getEntityLabel(props.detail.fromEntity) }}
    </vl-properties-data>
    <vl-properties-label>{{ $t('operationEntityDataMapping.detail.toEntity') }}</vl-properties-label>
    <vl-properties-data>
      {{ getEntityLabel(props.detail.toEntity) }}
    </vl-properties-data>
  </vl-properties-list>
  <vl-grid v-vl-spacer:top.medium>
    <vl-column>
      <OperationEntityDataMappingAttributesRead :detail="detail" />
    </vl-column>
  </vl-grid>
</template>

<script lang="ts" setup>
import { OperationEntityDataMappingDetailDto, OperationEntityDetailDto } from '@/api/backoffice/clients';
import OperationEntityDataMappingAttributesRead from './OperationEntityDataMappingAttributesRead.vue';

const props = defineProps<{
  detail: OperationEntityDataMappingDetailDto;
}>();

const getEntityLabel = (entity: OperationEntityDetailDto): string => {
  return entity ? `[${entity.id}] ${entity.label}` : '-';
};
</script>
